// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.issues_spinnerBox__gE98B{
    transform: rotate(46deg);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.issues_spinnerBox__gE98B p{
    transform: rotate(-47deg);
    font-size: 15px;
    font-weight: bold;
}
.issues_spinnerBox2__qfBvd{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border-width: 15px 16px 16px;
    border-style: solid;
    border-color: blue rgb(243, 243, 243) rgb(243, 243, 243);
    border-image: initial;
}

.issues_mobileBoxes__diL-z{
    width: 45%;
    box-shadow: grey 3px 3px 6px 1px;
    border: 1px solid grey;
    border-radius: 10px;
    background: white;
}

.issues_mobileBoxes__diL-z .issues_counti__46SHl {
    font-size: 29px;
    color: black;
    font-weight: bold;
    /* margin: 0.25rem 0rem; */
}

.issues_ticketlist__bu8Pm{
    width: 60%;
    /* max-height: 90vh; */
}
.issues_countmain__HMCbS{
    width: 35%;
    gap: 1rem;
}

.issues_graphmain__hgczW{
    width: 100%;
}

.issues_main__BUs-4{
    flex-direction: column;
}

.issues_piechart__zlQSI{
    display: flex;
    height: 200px;
  

}

@media screen  and (max-width: 426px){
    .issues_ticketlist__bu8Pm{
        width: 100%;
        max-height: 400px;
        overflow: scroll;
    }

    .issues_countmain__HMCbS{
        width: 100%;
    }

    .issues_graphmain__hgczW{
        width: 100%;
    }

    .issues_main__BUs-4{
        flex-direction: column-reverse;
    }

    .issues_piechart__zlQSI{
        display: none;
    }
    
    
}

.issues_fixed_width__PLpi9 {
    width: 300px; 
}

.issues_search_filter__yj8Jm {
    overflow: auto;
}

.issues_search_filter__yj8Jm::-webkit-scrollbar {
    width: 3px;
    height: 3px;
}

.issues_search_filter__yj8Jm::-webkit-scrollbar-track {
    background: #f1f1f1; 
    border-radius: 1rem; 
}

.issues_search_filter__yj8Jm::-webkit-scrollbar-thumb {
    background-color: #007bff; 
    border-radius: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Issues/issues.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,wDAAwD;IACxD,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,aAAa;;;AAGjB;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;;;AAGJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".spinnerBox{\n    transform: rotate(46deg);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n}\n.spinnerBox p{\n    transform: rotate(-47deg);\n    font-size: 15px;\n    font-weight: bold;\n}\n.spinnerBox2{\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    border-width: 15px 16px 16px;\n    border-style: solid;\n    border-color: blue rgb(243, 243, 243) rgb(243, 243, 243);\n    border-image: initial;\n}\n\n.mobileBoxes{\n    width: 45%;\n    box-shadow: grey 3px 3px 6px 1px;\n    border: 1px solid grey;\n    border-radius: 10px;\n    background: white;\n}\n\n.mobileBoxes .counti {\n    font-size: 29px;\n    color: black;\n    font-weight: bold;\n    /* margin: 0.25rem 0rem; */\n}\n\n.ticketlist{\n    width: 60%;\n    /* max-height: 90vh; */\n}\n.countmain{\n    width: 35%;\n    gap: 1rem;\n}\n\n.graphmain{\n    width: 100%;\n}\n\n.main{\n    flex-direction: column;\n}\n\n.piechart{\n    display: flex;\n    height: 200px;\n  \n\n}\n\n@media screen  and (max-width: 426px){\n    .ticketlist{\n        width: 100%;\n        max-height: 400px;\n        overflow: scroll;\n    }\n\n    .countmain{\n        width: 100%;\n    }\n\n    .graphmain{\n        width: 100%;\n    }\n\n    .main{\n        flex-direction: column-reverse;\n    }\n\n    .piechart{\n        display: none;\n    }\n    \n    \n}\n\n.fixed_width {\n    width: 300px; \n}\n\n.search_filter {\n    overflow: auto;\n}\n\n.search_filter::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n}\n\n.search_filter::-webkit-scrollbar-track {\n    background: #f1f1f1; \n    border-radius: 1rem; \n}\n\n.search_filter::-webkit-scrollbar-thumb {\n    background-color: #007bff; \n    border-radius: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerBox": `issues_spinnerBox__gE98B`,
	"spinnerBox2": `issues_spinnerBox2__qfBvd`,
	"mobileBoxes": `issues_mobileBoxes__diL-z`,
	"counti": `issues_counti__46SHl`,
	"ticketlist": `issues_ticketlist__bu8Pm`,
	"countmain": `issues_countmain__HMCbS`,
	"graphmain": `issues_graphmain__hgczW`,
	"main": `issues_main__BUs-4`,
	"piechart": `issues_piechart__zlQSI`,
	"fixed_width": `issues_fixed_width__PLpi9`,
	"search_filter": `issues_search_filter__yj8Jm`
};
export default ___CSS_LOADER_EXPORT___;
